"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RootBaseNotValidException extends Error {
    constructor() {
        super(`Il valore di 'rootBase' deve essere espresso in pixel: Es. '16px'`);
    }
}
exports.RootBaseNotValidException = RootBaseNotValidException;
class UnitNotValidException extends Error {
    constructor(unit, units) {
        super(`L'unità '${unit}' non è stata trovata.\nI valori possibili sono: '${units.join(', ')}'`);
    }
}
exports.UnitNotValidException = UnitNotValidException;
class RatioNotValidException extends Error {
    constructor(ratios) {
        super(`Il valore di 'ratio' non è valido. Inserire un valore numerico oppure una costante tra: ${Object.keys(ratios).map(v => v + `(${ratios[v]})`).join(', ')}`);
    }
}
exports.RatioNotValidException = RatioNotValidException;
//# sourceMappingURL=ModularScaleExceptions.js.map